import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/services/auth.service';
import { withAuthHeaders } from './auth-headers';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(private authService: AuthService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!request.url.startsWith(environment.apiUrl)) {
			return next.handle(request);
		}
		return next.handle(withAuthHeaders(request, {
			token: this.authService.token,
			xsrfToken: this.authService.xsrfToken
		}));
	}
}
